import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../components/form/FormInputText";
import FormInputNumber from "../../../../components/form/FormInputNumber";
import FormInputBooleanSwitch from "../../../../components/form/FormInputBooleanSwitch";
import FormSelectMessage from "../../../../components/form/FormSelectMessage";
import CdoOpcCommand from "./CdoOpcCommand";
// INTERFACES
import {
	OpcMappingsInterface,
	OpcCommandType,
	MessageToOpcEntryInterface,
	ResponseContentTypesInterface,
	ReadContentTypesInterface,
	WriteContentTypesInterface,
	OpcCommand,
} from "../../../../../interfaces/AdapterCdoOpc.interface";

export default function CdoOpcMappingMsgToOpcCmd({
	setValue,
	opcMapping,
}: {
	setValue: (newValue: any) => void;
	opcMapping: OpcMappingsInterface;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [msgToOpcCmd, setMsgToOpcCmd] = useState<{
		command: OpcCommand;
		opcCommand: OpcCommandType;
		address: string;
		description: string;
		msg_id: string;
		active: boolean;
		position: number;
		responseContentType: ResponseContentTypesInterface;
		readContentType: ReadContentTypesInterface;
		writeContentType: WriteContentTypesInterface;
	}>({
		command: {},
		opcCommand: "read_content_table",
		address: "",
		description: "",
		msg_id: "",
		active: true,
		position: 0,
		responseContentType: "read_item_response",
		readContentType: "read_sync_item_message",
		writeContentType: "make_group",
	});

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickAddNewMsgToOpcCmd = () => {
		const newMsgToOpcCmd: MessageToOpcEntryInterface = {
			value: {
				[msgToOpcCmd.opcCommand]:
					msgToOpcCmd.command.read_content_table ||
					msgToOpcCmd.command.response_content_table ||
					msgToOpcCmd.command.write_content_table,
			},
			key: {
				msg_id: msgToOpcCmd.msg_id,
				active: msgToOpcCmd.active,
				position: msgToOpcCmd.position,
			},
		};
		const copy = structuredClone(opcMapping);
		copy.msg_to_opc_cmd.push(newMsgToOpcCmd);
		setValue(copy);
		setMsgToOpcCmd({
			command: {},
			opcCommand: "read_content_table",
			address: "",
			description: "",
			msg_id: "",
			active: true,
			position: 0,
			responseContentType: "read_item_response",
			readContentType: "read_sync_item_message",
			writeContentType: "add_item",
		});
	};

	const onChangeMsgToOpcCmd = (
		newValue: string | boolean | number,
		variableName: string,
	) => {
		const copy = structuredClone(msgToOpcCmd);
		if (variableName === "address" && typeof newValue === "string") {
			copy.address = newValue;
		} else if (variableName === "msg_id" && typeof newValue === "string") {
			copy.msg_id = newValue;
		} else if (variableName === "description" && typeof newValue === "string") {
			copy.description = newValue;
		} else if (variableName === "active" && typeof newValue === "boolean") {
			copy.active = newValue;
		} else if (variableName === "position" && typeof newValue === "number") {
			copy.position = newValue;
		}
		setMsgToOpcCmd(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<CdoOpcCommand setOpcCommand={setMsgToOpcCmd} opcCommand={msgToOpcCmd} />
			<FormInputText
				inputValue={msgToOpcCmd.address}
				inputLabelName={t("general.address")}
				inputOnChange={onChangeMsgToOpcCmd}
				inputVariableName='address'
				isRequired
				
				disabledInput={false}
			/>
			<FormInputText
				inputValue={msgToOpcCmd.description}
				inputLabelName={t("general.description")}
				inputOnChange={onChangeMsgToOpcCmd}
				inputVariableName='description'
				isRequired
				disabledInput={false}
				
			/>
			<FormSelectMessage
				inputValue={msgToOpcCmd.msg_id}
				inputOnChange={onChangeMsgToOpcCmd}
				disabledInput={false}
				displaySelect
			/>
			<FormInputNumber
				inputValue={msgToOpcCmd.position}
				inputOnChange={onChangeMsgToOpcCmd}
				inputLabelName={t("general.position")}
				inputVariableName='position'
				
			/>
			<FormInputBooleanSwitch
				value={msgToOpcCmd.active}
				onChangeSwitch={onChangeMsgToOpcCmd}
				labelName={t("general.active")}
				variableName='active'
				isRequired
				
				disabledInput={false}
			/>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							disabled={msgToOpcCmd.address === "" || msgToOpcCmd.msg_id === ""}
							onClick={onClickAddNewMsgToOpcCmd}
							className={`generalStyles__width100 ${
								msgToOpcCmd.address === "" || msgToOpcCmd.msg_id === ""
									? ""
									: "buttonStyle__28"
							}`}
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.add")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
		</div>
	);
}
